export const formatSearchData = (data = {items: []}) => {
    if(data.items && data.items.length === 0) return data;
    const searchData = Object.assign({},data);
    searchData.items = data.items.map(item => {
        return Object.assign({},item,{name: item.name.replace(/#\w+/g,'')});
    });
    return searchData;
};


// WEBPACK FOOTER //
// ./src/components/util/formatSearchData.js